"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapCoreComponent = wrapCoreComponent;
var _react = _interopRequireDefault(require("react"));
var _defaults = _interopRequireDefault(require("lodash/defaults"));
var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Wrap a core component, pass props through.
 */
function wrapCoreComponent(_ref) {
  let {
    Component,
    defaultProps
  } = _ref;
  const WrappedComponent = props => {
    const propsWithDefaults = (0, _defaults.default)({}, props, defaultProps);
    return /*#__PURE__*/_react.default.createElement(Component, propsWithDefaults);
  };
  (0, _hoistNonReactStatics.default)(WrappedComponent, Component);
  return WrappedComponent;
}